<div class="form-element" *ngIf="labelName">
  <p class="bo-info-text form-element subtitle-section my-15 fs-14" [innerHtml]="labelName | localizeLabel"></p>
</div>

<div *ngIf="!hideFindAddress" class="form-element">
  <a
    class="use-previous-link vo-link"
    (click)="findPreviousAddresses()"
    [innerHtml]="referenceDataLabels.BrowseAddressesFromListId | localizeLabel"
  ></a>
</div>

<ng-container *ngIf="previousAddressOpened">
  <kendo-dialog
    class="vo-modal vo-modal--large vo-list-view-container form-address-modal"
    [title]="referenceDataLabels.FindAddressId | localizeLabel"
    (close)="close()"
    (keyup.escape)="close()"
  >
    <boi-form-listview [(selectedValue)]="selectedAddress" [dataList]="previousAddresses"></boi-form-listview>
    <kendo-dialog-actions class="modal-buttons">
      <a
        (click)="close()"
        [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
        class="link vo-secondary-button-1 mb-15 mb-md-0"
      ></a>
      <button
        (click)="confirm()"
        [innerHtml]="referenceDataLabels.SelectAddress | localizeLabel"
        class="primary-button vo-primary-button-1"
      ></button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>

<boi-form-radio-button
  *ngIf="showCountryCode"
  [controlId]="propertyName + referenceDataLabels.CountryId"
  [labelName]="referenceDataLabels.CountryId"
  [optionList]="referenceDataOptionLists.CountryType"
  [(value)]="address.CountryTypeCode"
  (ngModelChange)="addressChange.emit(this.address)"
  (valueChange)="checkCountryTypeIsUk()"
  [isFieldDisabled]="areFieldsDisabled || mortgageApplication?.IsApplicationReadOnly"
  [contextualHelpName]="contextualHelpName"
  [forceNotRequired]="true"
>
</boi-form-radio-button>

<ng-container
  *ngIf="
    address.CountryTypeCode === referenceDataOptionLists.CountryTypeUk && !forcePostcodeNotRequired;
    else postcodeNotRequired
  "
>
  <boi-form-text-input
    class="form-address-postal-code"
    [controlId]="propertyName + referenceDataLabels.PostcodeId"
    [propertyNames]="[propertyName + '.Postcode']"
    [labelName]="referenceDataLabels.PostcodeId"
    [forceRequired]="true"
    [fieldMaxLength]="15"
    [(value)]="address.Postcode"
    (blurChange)="setPostCodeUpperCase()"
    (ngModelChange)="addressChange.emit(address)"
    [tooltipName]="showSolicitorTooltip ? referenceDataLabels.PostcodeMandatory : referenceDataLabels.PostcodeId"
    [isFieldDisabled]="
      areFieldsDisabled ||
      mortgageApplication?.IsApplicationReadOnly ||
      (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)
    "
    [contextualHelpName]="contextualHelpName"
  >
    <button
      *ngIf="!hideFindAddress && isCountryTypeUk"
      class="primary-button vo-secondary-button-1 ml-md-30 full-width-md-button"
      (click)="findAddresses()"
      [innerHtml]="referenceDataLabels.FindAddressId | localizeLabel"
      [disabled]="areFieldsDisabled || isFindAddressButtonDisabled"
    ></button>
  </boi-form-text-input>
</ng-container>

<ng-template #postcodeNotRequired>
  <boi-form-text-input
    class="form-address-postal-code"
    [controlId]="propertyName + referenceDataLabels.PostcodeId"
    [propertyNames]="[propertyName + '.Postcode']"
    [labelName]="referenceDataLabels.PostcodeId"
    [fieldMaxLength]="15"
    [(value)]="address.Postcode"
    (blurChange)="setPostCodeUpperCase()"
    (ngModelChange)="addressChange.emit(address)"
    [isFieldDisabled]="
      areFieldsDisabled ||
      mortgageApplication?.IsApplicationReadOnly ||
      (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)
    "
    [contextualHelpName]="contextualHelpName"
  >
    <button
      *ngIf="!hideFindAddress && isCountryTypeUk"
      class="primary-button vo-secondary-button-1 ml-md-30 full-width-md-button"
      (click)="findAddresses()"
      [innerHtml]="referenceDataLabels.FindAddressId | localizeLabel"
      [disabled]="areFieldsDisabled || isFindAddressButtonDisabled"
    ></button>
  </boi-form-text-input>
</ng-template>

<ng-container *ngIf="addressOpened">
  <kendo-dialog
    class="vo-modal vo-modal--large vo-list-view-container form-address-modal"
    [title]="referenceDataLabels.FindAddressId | localizeLabel"
    (close)="close()"
    (keyup.escape)="close()"
  >
    <boi-form-listview [(selectedValue)]="selectedAddress" [dataList]="addresses"></boi-form-listview>

    <kendo-dialog-actions class="modal-buttons">
      <a
        (click)="close()"
        [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
        class="link vo-secondary-button-1 mb-15 mb-md-0"
      ></a>
      <button
        (click)="confirm()"
        class="primary-button vo-primary-button-1"
        [innerHtml]="referenceDataLabels.SelectAddress | localizeLabel"
      ></button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>

<boi-form-text-input
  [controlId]="propertyName + referenceDataLabels.AddressLine1"
  [propertyNames]="[propertyName + '.AddressLine1']"
  [labelName]="addressLine1Required ? referenceDataLabels.AddressLine1Mandatory : referenceDataLabels.AddressLine1"
  [fieldMaxLength]="40"
  [(value)]="address.AddressLine1"
  (ngModelChange)="addressChange.emit(address)"
  [isFieldDisabled]="areFieldsDisabled || mortgageApplication?.IsApplicationReadOnly"
  [contextualHelpName]="contextualHelpName"
>
</boi-form-text-input>

<boi-form-text-input
  [controlId]="propertyName + referenceDataLabels.AddressLine2"
  [labelName]="referenceDataLabels.AddressLine2"
  [(value)]="address.AddressLine2"
  (ngModelChange)="addressChange.emit(address)"
  [fieldMaxLength]="40"
  [isFieldDisabled]="areFieldsDisabled || mortgageApplication?.IsApplicationReadOnly"
  [contextualHelpName]="contextualHelpName"
>
</boi-form-text-input>

<boi-form-text-input
  [controlId]="propertyName + referenceDataLabels.AddressLine3"
  [labelName]="referenceDataLabels.AddressLine3"
  [(value)]="address.AddressLine3"
  (ngModelChange)="addressChange.emit(address)"
  [fieldMaxLength]="40"
  [isFieldDisabled]="areFieldsDisabled || mortgageApplication?.IsApplicationReadOnly"
  [contextualHelpName]="contextualHelpName"
>
</boi-form-text-input>

<boi-form-text-input
  [controlId]="propertyName + referenceDataLabels.CountyId"
  [labelName]="referenceDataLabels.CountyId"
  [isFieldDisabled]="areFieldsDisabled || mortgageApplication?.IsApplicationReadOnly"
  [(value)]="address.County"
  (ngModelChange)="addressChange.emit(address)"
  [fieldMaxLength]="40"
  [contextualHelpName]="contextualHelpName"
>
</boi-form-text-input>
